import axios from "axios";
import { CUSTOMER_API_URL } from "../constants";
import { Setting } from "../App";
import { SubscriptionsApiType, SurveyAnswer } from "../types/api/subscriptions-api-type";

export const useSubscriptionCancel = (setting: Setting) => {
  const subscriptionCancel = (
    success: () => void,
    failed?: (message: string) => void,
    surveyAnswer?: SurveyAnswer
  ) => {
    (async () => {
      try {
        const response = await axios.post(
          `${CUSTOMER_API_URL}?action=getSubscriptions`,
          {},
          { headers: { Authorization: setting.token } }
        );

        const subscriptions = (response.data as SubscriptionsApiType).filter(
          (subscription) => subscription.status === "ACTIVE" || subscription.status === 'PAUSED'
        );
        if (subscriptions.length === 0) return;

        const subscription = subscriptions[0];

        const param = {
          subscriptionId: subscription.subscriptionContractId,
          status: "cancelled",
        }

        const selected = surveyAnswer?.selected.join(',');
        const extraField = surveyAnswer?.extraField;

        const added = selected || extraField 
          ? { ...param, survey: { selected, extraField } } : param;
            
        console.log('use-subscription-cancel', param, surveyAnswer, added);

        await axios.post(
          `${CUSTOMER_API_URL}?action=updateSubscription`,
          added,
          {
            headers: { Authorization: setting.token },
          }
        );
        success();
      } catch (e) {
        if (failed) {
          failed(e.message);
        }
      }
    })();
  };

  return {
    subscriptionCancel,
  };
};
